var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conut-box"},[_c('button',{staticClass:"minus",on:{"click":_vm.sub}},[_vm._v(" - ")]),_c('input',{staticClass:"inp",attrs:{"type":"number"},domProps:{"value":_vm.value}}),_c('button',{staticClass:"add",on:{"click":_vm.add}},[_vm._v(" + ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }